import { ColorPrimary } from "../../library/utilities/variables";
export const BlueTheme = {
    primaryColor: ColorPrimary.lightBlue,
    feedbackBackgroundUrl: '/static/website/images_apps/themes/blue/feedback-background--blue.svg',
    character: {
        start: '/static/website/images_apps/themes/blue/char-start--blue.svg',
        middle: '/static/website/images_apps/themes/blue/char-middle--blue.svg',
        end: '/static/website/images_apps/themes/blue/char-end--blue.svg'
    },
};
